module.exports = __webpack_public_path__ + "static/media/MAKENZY – IDEAL PROCESS.14f852af.gif";